var globalFunctions = {

};

globalFunctions.debounce = function(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;
            
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;
        
        clearTimeout(timeout);

        timeout = setTimeout(later, wait);
        
        if (callNow) func.apply(context, args);
    };
};

globalFunctions.resizeImages = function(selector) {
    if (!selector)
        return;

    var $img = $(selector);
    
    $img.css('height','');
    
    var heights = $img.map(function () { return $(this).height(); }).get();
    var maxHeight = Math.max.apply(null, heights);
    
    $img.css('height', maxHeight + 'px');
};

globalFunctions.resizeProductResultsImages = function() {
    globalFunctions.resizeImages('.category-content__list.js-search-content .category-content__img');
};

globalFunctions.resizeProductResultsImagesDebounced = globalFunctions.debounce(globalFunctions.resizeProductResultsImages, 100);

globalFunctions.resizeNearbyExperiencesImages = function() {
    globalFunctions.resizeImages('.experiences .experiences-item__img-wrap__flex-height');
};

globalFunctions.resizeNearbyExperiencesImagesDebounced = globalFunctions.debounce(globalFunctions.resizeNearbyExperiencesImages, 100);

export default globalFunctions;


// WEBPACK FOOTER //
// ./resources/assets/js/components/common/global-functions.js